import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
  window.scrollTo(0, 0);
  const timer = setTimeout(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, 100);
  return () => clearTimeout(timer);
}, [pathname]);

  return null; // This component doesn't render anything
};